import { render, staticRenderFns } from "./FormGrupo.vue?vue&type=template&id=18da6a50&scoped=true"
import script from "./FormGrupo.vue?vue&type=script&lang=js"
export * from "./FormGrupo.vue?vue&type=script&lang=js"
import style0 from "./FormGrupo.vue?vue&type=style&index=0&id=18da6a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da6a50",
  null
  
)

export default component.exports